module.exports = __webpack_public_path__ + "static/media/ufo.0fe6b4ea.svg";